import React from 'react';
import './LoadingSkeleton.less';

function LoadingSkeleton({ width = '100%', height = 16, radius, className = '', style = {} }) {
  return (
    <span
      className={`gc-skeleton ${className}`.trim()}
      style={{ width, height, borderRadius: radius, ...style }}
      aria-hidden="true"
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="gc-skeleton-card">
      <LoadingSkeleton height={14} width="35%" />
      <LoadingSkeleton height={22} width="60%" style={{ marginTop: 12 }} />
      <LoadingSkeleton height={14} width="80%" style={{ marginTop: 10 }} />
    </div>
  );
}

export default LoadingSkeleton;
